import styled from 'styled-components';

export default styled.div`
  .ant-table-row {
    .ant-table-row-expand-icon-cell {
      display: none;
    }
  }
  .ant-table-wrapper {
    margin: 0 !important;
  }

  .ant-table-tbody > tr > td {
    padding: 3.5px 12px !important;
    color: ${({ theme }) => theme.colors.grayPrimary} !important;
    border-bottom: none !important;
  }
  .ant-table-tbody > tr > td:nth-child(n + 2) {
    text-align: right;
  }

  .ant-table-cell-with-append {
    display: flex;
    align-items: center;
    svg:hover {
      cursor: pointer;
    }
  }

  .ant-table-measure-row {
    display: none;
  }

  .ant-table-wrapper
    .ant-table-container
    table
    > tbody
    > tr:last-child
    > *:last-child {
    border-end-end-radius: 0px !important;
  }
  .ant-table-wrapper
    .ant-table-container
    table
    > tbody
    > tr:last-child
    > *:first-child {
    border-end-start-radius: 0px !important;
  }

  .ant-table-row-expand-icon {
    margin-right: 8px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .ant-table-expanded-row {
    position: relative;
  }

  .ant-table-row[data-row-key='1'] > td:first-child,
  .ant-table-row[data-row-key='2'] > td:first-child,
  .ant-table-row[data-row-key='3'] > td:first-child,
  .ant-table-row[data-row-key='4'] > td:first-child,
  .ant-table-row[data-row-key='8'] > td:first-child,
  .ant-table-row[data-row-key='5'] > td:first-child,
  .ant-table-row[data-row-key='7'] > td:first-child,
  .ant-table-row[data-row-key='9'] > td:first-child,
  .ant-table-row[data-row-key='12'] > td:first-child,
  .ant-table-row[data-row-key='13'] > td:first-child,
  .ant-table-row[data-row-key='14'] > td:first-child,
  .ant-table-row[data-row-key='15'] > td:first-child,
  .ant-table-row[data-row-key='19'] > td:first-child,
  .ant-table-row[data-row-key='18'] > td:first-child {
    background-color: ${({ theme }) => theme.colors.light} !important;
  }

  .ant-table-row[data-row-key='6'] > td,
  .ant-table-row[data-row-key='11'] > td,
  .ant-table-row[data-row-key='16'] > td,
  .ant-table-row[data-row-key='24'] > td,
  .ant-table-row[data-row-key='20'] > td,
  .ant-table-row[data-row-key='10'] > td {
    background-color: ${({ theme }) => theme.colors.blueLightest} !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayPrimary} !important;
  }

  .ant-table-row[data-row-key='11'] > td,
  .ant-table-row[data-row-key='17'] > td {
    background-color: ${({ theme }) => theme.colors.blueLightest} !important;
    &:first-child {
      font-weight: 700 !important;
    }
  }

  .ant-table-row[data-row-key='20'] > td {
    border-top: 1px solid ${({ theme }) => theme.colors.grayPrimary} !important;
  }

  .ant-table-row[data-row-key='6'] > td:first-child,
  .ant-table-row[data-row-key='11'] > td:first-child,
  .ant-table-row[data-row-key='16'] > td:first-child,
  .ant-table-row[data-row-key='24'] > td:first-child,
  .ant-table-row[data-row-key='20'] > td:first-child,
  .ant-table-row[data-row-key='10'] > td:first-child {
    font-weight: 700 !important;
  }

  .ant-table-row[data-row-key='21'] > td,
  .ant-table-row[data-row-key='22'] > td,
  .ant-table-row[data-row-key='23'] > td {
    background-color: ${({ theme }) => theme.colors.blueLightest} !important;
    font-weight: 700 !important;
  }
`;
